/* unplugin-vue-components disabled */import { render } from "./Layout.vue?vue&type=template&id=9867b91c&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=9867b91c&lang=scss&scoped=true"

import exportComponent from "/var/workhome/jenkins/jenkins_home/workspace/prod-vue-mt-comp-sso/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9867b91c"]])

export default __exports__